import React from 'react';

import useKnowledgeBaseEnabled from './hooks/useKnowledgeBaseEnabled';
import useOpenCoachDrawer from './hooks/useOpenCoachDrawer';
import { CoachOrbButton } from './CoachOrbButton';
import CoachRightDrawer from './CoachRightDrawer';

function KnowledgeBase() {
  const { isCoachOpen, openCoach, closeCoach } = useOpenCoachDrawer({
    syncInQueryParam: true,
  });

  const isKnowledgeBaseEnabled = useKnowledgeBaseEnabled();

  if (!isKnowledgeBaseEnabled) {
    return null;
  }

  return (
    <>
      <CoachOrbButton isOpen={isCoachOpen} onClick={openCoach} />
      <CoachRightDrawer isOpen={isCoachOpen} onClose={closeCoach} />
    </>
  );
}

export default React.memo(KnowledgeBase);
